import { isRoleSandbox } from "@/lib/runtimeMode";
import { useLayoutEffect } from "react";
import { mobilePlatform } from "./mobilePlatform";
export function useMobilePlatform() {
  useLayoutEffect(() => {
    const root = document.documentElement;
    const previous = root.dataset.mobilePlatform;
    const updatePlatform = () => {
      const preview = root.dataset.mobilePreviewPlatform;
      root.dataset.mobilePlatform =
        isRoleSandbox() && (preview === "ios" || preview === "android")
          ? preview
          : mobilePlatform(
              navigator.userAgent,
              navigator.platform,
              navigator.maxTouchPoints,
            );
    };
    updatePlatform();
    document.addEventListener("rovero-mobile-platform-change", updatePlatform);
    let baseline = window.innerHeight;
    const viewport = window.visualViewport;
    const checkKeyboard = () => {
      const editing = document.activeElement?.matches(
        'textarea,[contenteditable="true"],input:not([type="checkbox"]):not([type="radio"]):not([type="file"]):not([type="button"]):not([type="submit"])',
      );
      if (!editing) baseline = window.innerHeight;
      if (editing && baseline - (viewport?.height ?? window.innerHeight) > 140)
        root.dataset.mobileKeyboard = "open";
      else delete root.dataset.mobileKeyboard;
    };
    const rotated = () => {
      baseline = window.innerHeight;
      checkKeyboard();
    };
    viewport?.addEventListener("resize", checkKeyboard);
    window.addEventListener("resize", checkKeyboard);
    window.addEventListener("orientationchange", rotated);
    document.addEventListener("focusin", checkKeyboard);
    document.addEventListener("focusout", checkKeyboard);
    return () => {
      viewport?.removeEventListener("resize", checkKeyboard);
      window.removeEventListener("resize", checkKeyboard);
      window.removeEventListener("orientationchange", rotated);
      document.removeEventListener("focusin", checkKeyboard);
      document.removeEventListener("focusout", checkKeyboard);
      delete root.dataset.mobileKeyboard;
      document.removeEventListener(
        "rovero-mobile-platform-change",
        updatePlatform,
      );
      if (previous) root.dataset.mobilePlatform = previous;
      else delete root.dataset.mobilePlatform;
    };
  }, []);
}
